const powerSocket = {
    namespaced: true,
    state: {
        powerSocketList: [],
        powerSocketStatuses: {},
        statusPollInterval: null
    },
    mutations: {
        updatePowerSocketList(state, newList) {
            state.powerSocketList = newList;
        },
        updatePowerSocketStatuses(state, newStatus) {
            state.powerSocketStatuses = newStatus;
        },
        setStatusPollInterval(state, interval) {
            state.statusPollInterval = interval;
        },
        clearStatusPollInterval(state) {
            if (state.statusPollInterval) {
                clearInterval(state.statusPollInterval);
            }
            state.statusPollInterval = null;
        }
    },
    actions: {
        getPowerSocketList(context) {
            this._vm.$traveller_http.get('/traveller/restui/powersocket/getPowerSockets')
            .then(function(response) {
                var newList = [];
                for (const i in response.data) {
                    newList.push(response.data[i]);
                    newList[i].powerSocketStatus = 'UNKNOWN';
                    newList[i].controlInfopoints = [];
                    newList[i].slaveDevices = [];
                    if (newList[i].status && newList[i].status.length) {
                        for (const j in newList[i].status) {
                            if (newList[i].status[j].name.toUpperCase() == 'POWER_SOCKET_STATUS') {
                                newList[i].powerSocketStatus = newList[i].status[j].value;
                            }
                        }
                    }
                    if (newList[i].attributes && newList[i].attributes.length) {
                        for (const j in newList[i].attributes) {
                            if (newList[i].attributes[j].name.toUpperCase() == 'IP') {
                                newList[i].ip = newList[i].attributes[j].value;
                            }
                            else if (newList[i].attributes[j].name.toUpperCase() == 'USERNAME') {
                                newList[i].username = newList[i].attributes[j].value;
                            }
                            else if (newList[i].attributes[j].name.toUpperCase() == 'PASSWORD') {
                                newList[i].password = newList[i].attributes[j].value;
                            }
                            else if (newList[i].attributes[j].name.toUpperCase() == 'CONTROL_INFOPOINT') {
                                newList[i].controlInfopoints.push(newList[i].attributes[j].value);
                            }
                            else if (newList[i].attributes[j].name.toUpperCase() == 'SLAVE_DEVICE') {
                                newList[i].slaveDevices.push(newList[i].attributes[j].value);
                            }
                        }
                    }
                }
                context.commit('updatePowerSocketList', newList);
            })
        },
        getPowerSocketStatuses(context) {
            this._vm.$traveller_http.get('/traveller/restui/powersocket/getPowerSocketStatuses')
            .then(response => {
                context.commit('updatePowerSocketStatuses', response.data);
            });
        },
        savePowerSocket(context, newPowerSocket) {
            delete newPowerSocket.powerSocketStatus;
            delete newPowerSocket.ip;
            delete newPowerSocket.username;
            delete newPowerSocket.password;
            delete newPowerSocket.controlInfopoints;
            delete newPowerSocket.slaveDevices;
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.post('/traveller/restui/powersocket/savePowerSocket', newPowerSocket)
                    .then(response => {
                        if (response.status == 200) {
                            context.dispatch('getPowerSocketList');
                            resolve(response);
                        } else {
                            reject();
                        }
                    })
                    .catch(error => {
                        reject(error);
                    })
            });
        },
        deletePowerSocket(context, id) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/powersocket/deletePowerSocket', { params: { "id": id } })
                    .then(response => {
                        if (response.status == 200) {
                            context.dispatch('getPowerSocketList');
                            resolve(response);
                        } else {
                            reject();
                        }
                    })
                    .catch(error => {
                        reject(error);
                    })
            });
        },
        sendCommand(_context, params) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/powersocket/sendCommand', { params: params })
                    .then(response => {
                        //if (response.status == 200) {
                        //    context.dispatch('getPowerSocketList');
                        //}
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    })
            });
        }
    }
}
export default powerSocket;